/**
 * @generated SignedSource<<534b657f78d9393f00c774afa442764f>>
 * @relayHash af0616eab8ea5c25f4abe13d1878b7d0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3e2e9ab820e90d629f5c0c049ddfd8e5ab8c6ce47d02d875103e759cd8ff2c92

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraSoftwareSummaryAppQuery } from './JiraSoftwareSummaryAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraSoftwareSummaryAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "3e2e9ab820e90d629f5c0c049ddfd8e5ab8c6ce47d02d875103e759cd8ff2c92",
    "metadata": {},
    "name": "JiraSoftwareSummaryAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
